var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [
      _vm._v(
        _vm._s(_vm.getActorName) +
          ' kullanıcısı "' +
          _vm._s(_vm.$_.get(_vm.activity, "payload.taskTitle")) +
          '" adlı göreve şu işbirlikçileri ekledi: ' +
          _vm._s(_vm.$_.get(_vm.activity, "payload.collaborators").join(", "))
      ),
      _vm.ruleSource
        ? _c("span", [
            _vm._v(" ("),
            _c("em", [_vm._v(_vm._s(_vm.ruleSource))]),
            _vm._v(" aracılığıyla)"),
          ])
        : _vm._e(),
      _vm._v("."),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }